import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

function GrafHistoricosPot() {
    const { t } = useTranslation();
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [confirmedStartDate, setConfirmedStartDate] = useState('');
    const [confirmedEndDate, setConfirmedEndDate] = useState('');

    // Función para convertir la fecha a milisegundos
    const dateToMilliseconds = (date) => {
        return new Date(date).getTime();
    };

    // URLs de los paneles con las fechas confirmadas en milisegundos
    const from = confirmedStartDate ? dateToMilliseconds(confirmedStartDate) : 'now-7d';
    const to = confirmedEndDate ? dateToMilliseconds(confirmedEndDate) : 'now';

    // Función para confirmar las fechas seleccionadas
    const handleConfirm = () => {
        setConfirmedStartDate(startDate);
        setConfirmedEndDate(endDate);
    };

    // Función para resetear las fechas a los últimos 5 días
    const handleReset = () => {
        const today = new Date();
        const fiveDaysAgo = new Date(today);
        fiveDaysAgo.setDate(today.getDate() - 7);

        setStartDate(fiveDaysAgo.toISOString().split('T')[0]); // Formato YYYY-MM-DD
        setEndDate(today.toISOString().split('T')[0]); // Formato YYYY-MM-DD
        setConfirmedStartDate(fiveDaysAgo.toISOString().split('T')[0]);
        setConfirmedEndDate(today.toISOString().split('T')[0]);
    };

    return (
        <>
            <div className="container-fluid">
                {/* Selección de fechas */}
                <div className="row mb-3">
                    <div className="col col-3">
                        <label htmlFor="startDate">{t('scada.solarFarm.historical.startDate')}&nbsp;</label>
                        <input
                            id="startDate"
                            type="date"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                        />
                    </div>
                    <div className="col col-3">
                        <label htmlFor="endDate">{t('scada.solarFarm.historical.endDate')}&nbsp;</label>
                        <input
                            id="endDate"
                            type="date"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                        />
                    </div>
                    <div className="col col-3 d-flex align-items-end">
                        <button onClick={handleConfirm} className="btn btn-primary me-2">{t('scada.solarFarm.historical.confirm')}</button>
                        <button onClick={handleReset} className="btn btn-secondary">{t('scada.solarFarm.historical.reset')}</button>
                    </div>
                </div>

                {/* Gráficos */}
                <div className="row">
                    <div className="col">
                        <object data={`https://eurus.energynebula.com/grafana/d-solo/7vsnb5ZHz/historicos?orgId=1&theme=light&panelId=2&from=${from}&to=${to}`} width="100%" height="400" frameBorder="0"></object>
                    </div>
                </div>
            </div>
        </>
    )
}

export default GrafHistoricosPot;
